var _path, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNoCard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 35,
    viewBox: "0 0 36 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.384 2.667h21.95A3.322 3.322 0 0135.667 6v20c0 .567-.133 1.1-.383 1.567l-2.95-2.95V16h-8.617L17.05 9.333h15.284V6H13.717l-3.333-3.333zm23.94 31.009c-.648.649-1.7.65-2.35.002l-4.357-4.345H5.667A3.322 3.322 0 012.334 26L2.35 6c0-.567.134-1.1.384-1.55L1.32 3.027A1.664 1.664 0 013.677.677l30.648 30.647c.649.65.649 1.702 0 2.352zM5.668 7.383v1.95h1.95l-1.95-1.95zM24.284 26l-10-10H5.667v10h18.617z",
    fill: "url(#no-card_svg__paint0_linear_11804_67476)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "no-card_svg__paint0_linear_11804_67476",
    x1: 19.998,
    y1: 65.889,
    x2: 48.696,
    y2: 53.269,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.016,
    stopColor: "#01D6B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#218FEE"
  })))));
}

export default SvgNoCard;